<template>
    <v-container class="fill-height" style="display: block;" fluid>


        <div class="modules-area">
            <v-row>
                <v-col cols="12" md="12" lg="12" xl="12" class="slide-in-right">
                    <v-card height="100" @click="runModule">
                        <v-card-text>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon x-large>mdi-sticker-alert</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <span style="font-size: 16px;">14 Days Issue Title Summary</span>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <span v-html="results"></span>
        </div>


        <div class="prompt-input-area">
            <div class="prompt-input">
                <v-text-field color="#c42111" outlined placeholder="Message AI..." v-model="promptText" @keyup.enter.native="sendMessage" :disabled="runningRequest">
                    <template v-slot:append>

                        <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mt-1" color="#c42111" width="20" max-width="20" min-width="20" @click="sendMessage" :disabled="!promptText || runningRequest" v-on="on">
                                    <v-icon>mdi-arrow-up-bold</v-icon>
                                </v-btn>
                            </template>
                            <span>Send Message</span>
                        </v-tooltip>

                    </template>
                </v-text-field>
            </div>
        </div>
        
        <div class="running-request-indicator-area" v-if="runningRequest">
            <div class="loader">
                <div class="inner one"></div>
                <div class="inner two"></div>
                <div class="inner three"></div>
            </div>
        </div>

        <div class="disclaimer-text-container">
            <span>This is a beta feature. The results may not be fully correct.</span>
        </div>


    </v-container>
</template>

<script>
export default {
    name: 'TelsappAI',
    props: [],
    components: {

    },
    data: () => ({
        module: null,
        results: ""
    }),

    computed: {

    },

    methods: {
        runModule: function() {
            console.log('run module!');
        }

    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .slide-in-right {
        animation: slide-in-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }

    @keyframes slide-in-right {
        0% {
            transform: translateX(1000px);
            opacity: 0;
        }
        100% {
            transform: translateX(0);
            opacity: 1;
        }
    }

</style>

<style scoped>

    .prompt-input-area {
        min-width: 600px;
        width: 80%;
        text-align: center;
        display: block;
        position: absolute;
        bottom: 10px;
        left: calc(20% / 2)
    }

    .prompt-input {
        max-width: 600px;
        display: block;
        text-align: center;
        position: relative;
        left: calc(50% - (600px / 2));
    }

    .disclaimer-text-container {
        min-width: 420px;
        width: 420px;
        text-align: center;
        display: block;
        position: absolute;
        bottom: 8px;
        left: calc(50% - (420px / 2));
    }
    .disclaimer-text-container span {
        color: rgba(255,255,255,0.8);
    }

</style>